// src/components/Portal.js (Nueva Versión)

import React from "react";
import { Stethoscope, ShieldPlus, BookMarked, FileText, ArrowRight } from "lucide-react";
import "../styles/Portal.css";

const Portal = () => {

  const handleComingSoonClick = (e) => {
    e.preventDefault(); 
    alert("Próximamente: sección en construcción");
  };

  return (
    <div className="portal-page-wrapper">
      <div className="portal-container">
        
        <header className="portal-header">
          <h1 className="portal-title">Portal del Personal</h1>
          <p className="portal-subtitle">
            Accedé a las herramientas y recursos internos de la clínica de forma rápida y segura.
          </p>
        </header>

        <div className="portal-grid">
          
          <a href="http://geclisa.clinicaciudad.ar/login?ReturnUrl=%2F" className="portal-card" target="_blank" rel="noopener noreferrer">
            <div className="card-icon-wrapper">
              <Stethoscope size={32} />
            </div>
            <div className="card-content">
              <h2 className="card-title">Acceso a Geclisa</h2>
              <p className="card-description">
                Gestión de historias clínicas.
              </p>
            </div>
            <ArrowRight className="card-arrow-icon" size={20} />
          </a>
          
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdIlN1v6v_iOEHW6IV5OYItfgzNBWKzXdOIMotQZ4Eu8Mg9dw/viewform" className="portal-card" target="_blank" rel="noopener noreferrer">
            <div className="card-icon-wrapper">
              <ShieldPlus size={32} />
            </div>
            <div className="card-content">
              <h2 className="card-title">Reporte de Incidentes</h2>
              <p className="card-description">
                Garantiza la seguridad del paciente.
              </p>
            </div>
            <ArrowRight className="card-arrow-icon" size={20} />
          </a>

          <a href="#" className="portal-card" onClick={handleComingSoonClick}>
            <div className="card-icon-wrapper">
              <BookMarked size={32} />
            </div>
            <div className="card-content">
              <h2 className="card-title">Protocolos Internos</h2>
              <p className="card-description">
                Consulta de guías y procedimientos.
              </p>
            </div>
            <ArrowRight className="card-arrow-icon" size={20} />
          </a>

          <a href="#" className="portal-card" onClick={handleComingSoonClick}>
            <div className="card-icon-wrapper">
              <FileText size={32} />
            </div>
            <div className="card-content">
              <h2 className="card-title">Informe de Estudios</h2>
              <p className="card-description">
                Resultados de laboratorio e imágenes.
              </p>
            </div>
            <ArrowRight className="card-arrow-icon" size={20} />
          </a>

        </div>
      </div>
    </div>
  );
};

export default Portal;